export default __webpack_public_path__ + "static/media/Head_1_Ear_1_C3.b5eab065.svg";